<template>
<div class="subs boards-group">
  <div class="board-row board-header">
    <div class="subscription-col board-header-label" @click="toggleOpen">
      <div class="padding-div"> </div>
      <span :class="caretObject"></span>
      {{board.boardName}}
    </div>
    <!-- <div class="subscription-col">
      <div class="imidiate-email">
        <input type="checkbox" v-model="immediate" @change="immediateChanged">
        <span>Immediate</span>
      </div>
    </div>
    <div class="subscription-col">
      <input type="checkbox" v-model="notification" @click="toggleBoardSubscription">
      <span>Immediate</span>
    </div> -->
  </div>
  <div v-if="showContent" :class="showContentClass">
    <subscription-topic-row v-for="topic in topics" :key="topic.topicID" :topic="topic" :emailSetting="getEmailSetting(topic.topicID)"></subscription-topic-row>
  </div>
</div>
</template>

<script>
import api from "../../../api/api";
import SubscriptionTopicRow from "./SubscriptionTopicRow.vue";

export default {
  components: {SubscriptionTopicRow},
  props: ['board', 'emailSettings'],
  data() {
    return {
      notification: false,
      immediate: false,
      daily: false,
      weekly: false,
      isOpen: false,
      topics: []
    }
  },
  mounted() {
    this.topics = this.board.topics;
    if(this.topics) {
      if(this.topics.every((b => b.subscribed))){
        this.notification = true;
      }
    }
  },
  computed: {
    caretObject() {
        return {
            'caret': true,
            'caret-down': this.isOpen
        }
    },
    showContentClass() {
      return {
          'subscription-board-rows': !this.isOpen,
          'subscription-board-rows-opened': this.isOpen
      }
    },
    showContent() {
      return this.topics != null && this.emailSettings != null && this.isOpen;
    }
  },
  created() {
    // this.notification = this.notificationProp;
  },
  watch: {
    board: {
      handler(val) {
        if(!val || !val.boards){
          this.topics = [];
          return;
        }
        this.topics = val.topics;
        if(this.topics.every((b => b.subscribed))){
          this.notification = true;
        }
        else{
          this.notification = false;
        }
        this.$forceUpdate();
      },
      deep: true,
    },
    emailSettings:{
      handler(val){
        let checked = true;
        if(!this.topics || this.topics.length == 0) {
          checked = false;
        }
        else{
          for(let i = 0; i < this.topics.length ; i++){
            let b = this.topics[0];
            let emailSetting = val.find(r=> r.topicId == b.topicID);
            if(!emailSetting || !emailSetting.immediate) {
              checked = false;
            }
          }
        }
        this.immediate = checked;
        this.$forceUpdate();
      },
      deep: true,
    }
  },
  methods: {
    notificationChanged() {
      this.$emit('changenotification', this.notification);
    },
    async immediateChanged() {
      const imediate = this.immediate;
      for(let i = 0; i < this.topics.length; i++){
        const topic = this.topics[i];
        const emailSettings = this.emailSettings.find(r => r.topicId == topic.topicID);
        if(emailSettings){
          await api.post('/Communication/topics/'+topic.topicID, {
            Immediate: imediate,
            Id: emailSettings.id,
          });
        }
      }
      this.$emit("refreshEmail");
    },
    dailyChanged() {
      this.$emit('dailyChanged', this.daily);
    },
    weeklyChanged() {
      this.$emit('weeklyChanged', this.weekly);
    },
    toggleOpen() {
        this.isOpen = !this.isOpen;
    },
    getEmailSetting(topicID) {
      if(!this.emailSettings) {
        return null;
      }
      const topic = this.emailSettings.find(r => r.topicId == topicID);
      return topic;
    },
    toggleBoardSubscription() {
      const realNotification = !this.notification;
      for(let i = 0; i < this.boards.length; i++){
        const topic = this.topics[i];
        if(realNotification === true) {
          api.post('/Subscription/topics', {
            TopicID: topic.topicID,
          }).catch(() => {
            alert('error while changing notification setting');
          });
        }
        else{
          api.delete('/Subscription/topics', {
            TopicID: topic.topicID,
          }).catch(() => {
            alert('error while changing notification setting');
          });
        }
      }
      setTimeout(() => {
        this.$emit("refresh");
      }, 750);
    }
  }
}
</script>

<style scoped>
.padding-div{
    min-width:40px;
    display: inline-block;
}
</style>